import { useEffect } from 'react';
import { Modal, ModalContent } from '@chakra-ui/react';

import useGetScheduleDetail from 'Domain/schedule/useGetScheduleDetail';
import usePostChangeHostBulk from 'Domain/schedule-change-host/usePostChangeHostBulk';
import ButtonSolid from 'UiKit/button/buttonSolid';

import Head from 'View/schedule-change-host/section/head';
import ScheduleTable from 'View/schedule-change-host/section/schedule-table';
import ScheduleChangeHostProvider, { useScheduleChangeHostState } from 'View/schedule-change-host/state';

import styles from './styles.module.css';

const ScheduleChangeHost = () => {
  const { scheduleChangeHostData, updateState } = useScheduleChangeHostState();

  const filterState = JSON.parse(sessionStorage.getItem('scheduleFilterState') || '{}');

  const { data, isLoading } = useGetScheduleDetail({
    enabled: true,
    payload: {
      ...filterState,
      hasActiveHost: false,
    },
  });

  const { mutate } = usePostChangeHostBulk({ filterState });

  const handleSave = () => {
    const errors = {};

    scheduleChangeHostData.forEach((brand) => {
      const activeDetails = brand.details.filter((d) => d.status !== 'delete' && d.selectedHosts?.length > 0);

      activeDetails.forEach((detail, i) => {
        activeDetails.forEach((other, j) => {
          if (i >= j) return;

          const sameTime = detail.startDate === other.startDate && detail.endDate === other.endDate;
          if (!sameTime) return;

          const hostIds = detail.selectedHosts.map((h) => h.value);
          const otherHostIds = other.selectedHosts.map((h) => h.value);
          const hasOverlap = hostIds.some((id) => otherHostIds.includes(id));

          if (hasOverlap) {
            errors[detail.id] = 'Jadwal host bentrok';
            errors[other.id] = 'Jadwal host bentrok';
          }
        });
      });
    });

    if (Object.keys(errors).length > 0) {
      updateState({ rowErrors: errors });
      return;
    }

    updateState({ rowErrors: {} });
    mutate({ data: scheduleChangeHostData });
  };

  useEffect(() => {
    if (!isLoading && data) {
      updateState({ scheduleChangeHostData: data?.schedules || [] });
    }

    /* eslint-disable-next-line */
  }, [isLoading, data]);

  return (
    <Modal isOpen={true} size={'full'}>
      <ModalContent width={'100%'} className={styles['schedule-change-host__container']}>
        <Head />
        <ScheduleTable schedules={scheduleChangeHostData} />
        <ButtonSolid className={styles['schedule-change-host__save-button']} onClick={handleSave}>
          Simpan Perubahan
        </ButtonSolid>
      </ModalContent>
    </Modal>
  );
};

const ScheduleChangeHostContainer = () => <ScheduleChangeHostProvider children={<ScheduleChangeHost />} />;

export default ScheduleChangeHostContainer;
